import * as React from 'react'
import styled from 'styled-components'
import Link from 'next/link'

import * as entities from '@owl-nest/entities'
import * as money from '@owl-nest/money'
import * as plume from '@ulule/owl-kit-components/next'

type ResultsProps = {
  className?: string
  products: entities.product.SearchHitProduct[]
  onProductClick?: (product: entities.product.SearchHitProduct) => void
}

export function Results({ className, products, onProductClick }: ResultsProps): React.ReactElement {
  return (
    <Grid className={className}>
      {products.map((product) => {
        return (
          <Link key={product.href} onClick={() => onProductClick && onProductClick(product)} href={product.href}>
            <plume.ProductCard
              brand={product.brand}
              criteria={product.criteria}
              picture={{
                ...product.picture,
                nativeLazyLoad: true,
              }}
              price={money.formatRange(product.priceRange)}
              originalPrice={product.compareAtPriceRange ? money.formatRange(product.compareAtPriceRange) : undefined}
              title={product.title}
              variantInformation={product.colors.length > 1 ? `${product.colors.length} couleurs` : undefined}
            />
          </Link>
        )
      })}
    </Grid>
  )
}

export function EmptyResults(): React.ReactElement {
  return <NoResults>Aucun résultat</NoResults>
}

const NoResults = styled.div`
  height: 130px;
  margin-top: 20px;
  margin-bottom: 60px;
  text-align: center;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    height: 170px;
  }
`

export type ResultsSkeletonProps = {
  length: number
}

export function ResultsSkeleton({ length }: ResultsSkeletonProps): React.ReactElement {
  return (
    <Grid>
      {Array.from({ length }).map((_, i) => (
        <plume.ProductCardSkeleton key={i} />
      ))}
    </Grid>
  )
}

const Grid = styled.section`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  grid-gap: 5px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    grid-template-columns: repeat(1, 1fr);
    justify-items: initial;
    grid-gap: 32px;

    & > * {
      margin-bottom: 0;
    }
  }

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (min-width: 1240px) {
    grid-template-columns: repeat(3, 1fr);
  }
`
